export default "__VITE_ASSET__567aa704__"